import { PointageSlider } from '@components';
import React from 'react';
import './PointagePage.scss';

export const PointagePage: React.FC = () => {
    return (
        <div className="pointage-page">
            <PointageSlider />
        </div>
    );
};
